"use strict";

exports.__esModule = true;
exports.default = prefixPropName;

var _upperFirst = require("./upper-first");

/**
 * @param {string} prefix
 * @param {string} value
 */
function prefixPropName(prefix, value) {
  return prefix + (0, _upperFirst.default)(value);
}


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/prefix-prop-name.js
// module id = 124
// module chunks = 0 3